/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-boviclic-cancel',
  templateUrl: './dialog-boviclic-cancel.component.html',
  styleUrls: ['./dialog-boviclic-cancel.component.scss']
})
export class DialogBoviclicCancelComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(public dialogRef: MatDialogRef<DialogBoviclicCancelComponent>) {
    // This is intentional
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              LISTENERS                                                                                             ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public close(res: boolean): void {
    this.dialogRef.close(res);
  }


}
